import {Component, Prop, Vue} from 'vue-property-decorator'
import {
  Modal,
  IModal
} from '@/entities'
import ModalBase from '@/components/modal/ModalBase.vue'

@Component({
  components: {
    ModalBase
  }
})
class modalBaseMixin extends Vue {

  @Prop({default: true}) readonly closable?: boolean

  private loading: boolean = true;
  private error: string = '';
  private stepError: string = '';

  private oneSubjectDetect(subject: any): void {
    const modal = this.modal;
    modal.subject = subject;
    let steps = modal.steps;
    const configStep = steps.find(s => s.name === 'config' );
    if (configStep) {
      // skip specific item config step if there's only one item to choose
      steps.splice(steps.indexOf(configStep), 1);
    }
  }

  get stepLoading(): boolean {
    return this.modal.currentStep?.loading || this.loading;
  }

  get initSubject(): any {
    return this.$store.state.modal?.subject;
  }

  get havePricedInitSubject(): boolean {
    return !!this.initSubject?.price;
  }

  get initStep(): string | undefined {
    return this.$store.state.modal?.step;
  }

  get hasError(): boolean {
    return !!(this.error || this.stepError);
  }

  protected modal: IModal = this.getModal(this.initSubject, this.initStep, this.havePricedInitSubject);

  protected getModal(initSubject: any, initStep?: string, specific?: boolean): IModal {
    return new Modal({
      name: () => this.$t('modals.titles.base') as string,
      close: this.$storage.actions.closeModal,
      stepName: initStep,
      subject: initSubject,
      steps: [
        {
          name: 'base',
          controls: [
            {
              type: 'ok'
            }
          ]
        }
      ]
    });
  }

  get subjectSimpleTitle(): string {
    let subject = this.modal.subject;
    return subject?.service_type?.name || subject?.name;
  }

  get subjectActualTitle(): string {
    let category = this.modal.subject.category;
    return (category ? (this.$options.filters?.capitalize(category) + ' '): '') + this.subjectSimpleTitle;
  }

  get subjectTitle(): string {
    return (this.modal.currentStep?.name === 'config') ? this.modal.title : this.subjectActualTitle;
  }

  get stepComponent(): string {
    return this.$options.name + this.$options.filters?.camelCase(this.modal.currentStep?.name);
  }

  mounted(): void {
    this.loading = false;
  }

}

export default modalBaseMixin
